export default "__VITE_ASSET__BhI$wKWL__"